import _slicedToArray from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _typeof from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/typeof.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.string.starts-with.js";
import "core-js/modules/es.string.link.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { getChannelList } from "@/services/customer/customerList";
import { getBrand, getClassify, getSourcearea, getTransport } from "@/services/productDetail";
import { getActivityList } from "@/services/marketing/activity";
import PdfUpload from "@/pages/design/components/FileUpload/pdfUpload.vue";

/**
 * 排序类型
 * @enum
 */
var _OrderTypes = {
  // 默认排序
  DEFAULT: 1,
  // 上架时间排序
  ONLINE: 2
};

/**
 * 页面类型
 *
 */
var PageTypes = {
  /** 搜索结果页面 **/
  SearchResult: '/product/search',
  /** 活动详情页面 **/
  ActivityDetail: '/activity/detail',
  /** PDF页面 **/
  Pdf: '/pdf'
};
export default {
  components: {
    PdfUpload: PdfUpload
  },
  i18n: require('../../design_i18n'),
  name: 'SetSearchParamsModal',
  props: {
    show: {
      type: Boolean
    },
    links: String
  },
  data: function data() {
    return {
      visible: this.show,
      form: {
        page: undefined,
        // 页面
        query: {
          channelcode: undefined,
          // 推广平台
          search: '',
          // 搜索关键字
          catagotyId: undefined,
          // 分类
          transportId: [],
          // 运输方式
          originId: undefined,
          // 原产地
          brandId: undefined,
          // 品牌
          orderType: undefined,
          // 排序类型
          sort: undefined,
          // 排序方式
          bundleChecked: undefined,
          // 是否同捆
          exactSearch: undefined,
          // 是否精确匹配
          page: undefined,
          // 页码
          activity: undefined,
          //活动
          title: undefined,
          // 分类标题
          pdf: undefined // pdf页面
        }
      },
      labelCol: {
        span: 6
      },
      // 页面列表options
      pageOptions: [
      //商品搜索结果
      {
        label: this.$t('form.productSearch'),
        value: PageTypes.SearchResult
      },
      // 活动详情
      {
        label: this.$t('form.activeDetail'),
        value: PageTypes.ActivityDetail
      },
      // PDF页面
      {
        label: this.$t('form.pdfPage'),
        value: PageTypes.Pdf
      }],
      exactOptions: [{
        label: this.$t('form.dimMatch'),
        value: 0
      },
      //模糊匹配
      {
        label: this.$t('form.exactMatch'),
        value: 1
      } // 精确匹配
      ],
      orderTypeListOptions: [{
        label: this.$t('form.defualtSort'),
        value: _OrderTypes.DEFAULT
      },
      // 默认排序
      {
        label: this.$t('form.stockSort'),
        value: _OrderTypes.ONLINE
      } // 上架时间排序
      ],
      // 排序类型列表options
      sortListOptions: [{
        label: this.$t('form.sort_up'),
        value: 1
      },
      // 升序
      {
        label: this.$t('form.sort_down'),
        value: 0
      } // 升序
      ],
      // 排序类型方式options
      channelListOptons: [],
      // 推广平台列表options
      categoryOptions: [],
      // 分类列表options
      brandOptions: [],
      // 品牌列表options
      transportOptions: [],
      // 运输方式列表options
      placeOfOriginOptions: [],
      // 原产地列表options
      langList: [],
      // 多语言列表
      seq: ',',
      // 运输方式分割符
      defaultLangId: '',
      // 默认语言
      activityList: [],
      // 活动中的活动列表。
      pdfList: [],
      // pdf 列表
      PageTypes: PageTypes
    };
  },
  watch: {
    show: function show(val) {
      this.visible = this.show;
    },
    visible: function visible() {
      this.$emit('update:show', this.visible);
    },
    links: function links() {
      this.init();
    }
  },
  computed: {
    OrderTypes: function OrderTypes() {
      return _OrderTypes;
    },
    /**
     * 匹配方式是否禁用
     */
    matchTypeDisable: function matchTypeDisable() {
      var search = this.form.query.search;
      var disabled = false;
      if (_typeof(search) === 'object') {
        var values = Object.values(search);
        if (values.length > 0) {
          var searchIsEmpty = values.some(function (search) {
            return search;
          });
          if (searchIsEmpty) {
            // 有一个关键字不为空就 取消禁用
            disabled = false;
          } else {
            disabled = true;

            // 如果关键字为空 就清空选择的匹配方式
            this.form.query.exactSearch = undefined;
          }
        } else {
          disabled = true;
        }
      } else {
        disabled = true;
      }
      return disabled;
    },
    /**
     * c端站点yum
     */
    siteDomain: function siteDomain() {
      return this.$store.state.setting.siteDomain;
    },
    clientPublicData: function clientPublicData() {
      return this.$store.state.design.clientPublicData;
    },
    imgHost: function imgHost() {
      return this.$store.state.design.imgHost;
    }
  },
  created: function created() {
    this.init();
    this.getData();
  },
  methods: {
    handleClearPdf: function handleClearPdf() {},
    handlePdfUploadSuccess: function handlePdfUploadSuccess(val) {
      if (this.clientPublicData && val) {
        this.form.query.pdf = encodeURIComponent(this.clientPublicData.catalogPageUrl + '?file=' + this.imgHost + val);
      }
    },
    /**
     *  处理使用同捆选中
     * @param e
     */
    handleBundleCheckChange: function handleBundleCheckChange(e) {
      console.log('e', e);
      this.form.query.bundleChecked = e.target.checked;
    },
    /**
     * 初始化
     */
    init: function init() {
      this.initParams();
      // this.initSearchKeyword()
    },
    /**
     * 初始化链接中的参数。
     */
    initParams: function initParams() {
      var url = this.links;
      if (!url) {
        // 如果没有link，不去解析参数
        return;
      }
      /** PDF页面 **/
      if (url.indexOf('viewer.html') != -1) {
        this.form.page = '/pdf';
        this.form.query.pdf = url;
        return;
      }

      /** PDF以外的页面 **/
      var path = url.replace(this.siteDomain, '');
      var page = '';
      var query = '';
      // 拆分page和query
      if (path.indexOf('?') >= 0) {
        var pathArr = path.split('?');
        page = pathArr[0];
        query = pathArr[1];
      } else {
        page = path;
      }
      if (path.startsWith(PageTypes.SearchResult)) {
        this.form.page = PageTypes.SearchResult;
      } else if (path.startsWith(PageTypes.ActivityDetail)) {
        this.form.page = PageTypes.ActivityDetail;
      } else {
        this.form.page = undefined;
        return;
      }
      console.log([page, query]);
      if (query) {
        this.initQuery(query);
      }
    },
    /**
     * 初始化query
     */
    initQuery: function initQuery(search) {
      var params = new URLSearchParams(search);
      if (params.has('catagotyId')) {
        this.form.query.catagotyId = parseInt(params.get('catagotyId'));
      }
      if (params.has('transportId')) {
        var transportId = params.get('transportId');
        this.form.query.transportId = transportId.split(this.seq).map(function (id) {
          return parseInt(id);
        });
      }
      if (params.has('originId')) {
        this.form.query.originId = parseInt(params.get('originId'));
      }
      if (params.has('brandId')) {
        this.form.query.brandId = parseInt(params.get('brandId'));
      }
      if (params.has('orderType')) {
        this.form.query.orderType = parseInt(params.get('orderType'));
      }
      if (params.has('search')) {
        this.form.query.search = params.get('search');
      }
      if (params.has('title')) {
        this.form.query.title = params.get('title');
      }
      if (params.has('activityId')) {
        this.form.query.activity = parseInt(params.get('activityId'));
      }
    },
    /**
     * 初始化搜索关键字
     */
    initSearchKeyword: function initSearchKeyword() {
      var _this = this;
      var langlist = localStorage.langList;
      langlist = JSON.parse(langlist);
      this.langList = langlist;

      // 根据localStorage初始化 titles
      if (langlist) {
        langlist.forEach(function (item) {
          var link = _this.links[item.langId].link;
          if (!link) {
            // 如果link不存在，不去解析search
            return;
          }
          var path = link.replace(_this.siteDomain, '');
          if (path.indexOf('?') >= 0) {
            if (_this.links && _this.links[item.langId]) {
              var _path$split = path.split('?'),
                _path$split2 = _slicedToArray(_path$split, 2),
                page = _path$split2[0],
                query = _path$split2[1];
              var searchParams = new URLSearchParams(query);
              _this.$set(_this.form.query.search, item.langId, searchParams.get('search'));
            } else {
              _this.$set(_this.form.query.search, item.langId, '');
            }
          } else {
            _this.$set(_this.form.query.search, item.langId, '');
          }
        });
      }
    },
    /**
     * 排序类型change
     */
    handleOrderTypeChange: function handleOrderTypeChange() {
      /**
       * 排序类型不为价格就清空排序方式
       */
      if (this.form.query.orderType !== _OrderTypes.PRICE) {
        this.form.query.sort = undefined;
      }
    },
    /**
     * 处理运输方式选中
     */
    handleTransportChange: function handleTransportChange() {
      if (_.isArray(this.form.query.transportId) && this.form.query.transportId.length > 0) {
        this.form.query.bundleChecked = true;
      } else {
        this.form.query.bundleChecked = undefined;
      }
    },
    /**
     * 获取数据
     */
    getData: function getData() {
      // this.getChannelData()
      this.getSearchContidionData();
      this.getAcitvityList();
    },
    getAcitvityList: function getAcitvityList() {
      var _this2 = this;
      getActivityList({
        page: 1,
        size: 999,
        activityStatus: 5 //活动中
      }).then(function (response) {
        var dataObj = response.data.data;
        if (response.data.code == 200) {
          _this2.activityList = dataObj.list;
        }
        // console.log(response)
      });
    },
    /**
     * 获取推广平台列表数据
     */
    getChannelData: function getChannelData() {
      var _this3 = this;
      getChannelList().then(function (res) {
        if (res.data.code == 200) {
          var list = res.data.data;
          _this3.channelListOptons = list.map(function (item) {
            return {
              label: item.channelName,
              value: item.channelCode
            };
          });
        }
      });
    },
    /**
     * 获取搜索条件数据
     */
    getSearchContidionData: function getSearchContidionData() {
      var _this4 = this;
      var self = this;
      var getObjClassify = {
        type: 1
      };
      getClassify(getObjClassify).then(function (res) {
        if (res.data.code == 200) {
          _this4.categoryOptions = res.data.data;
        }
      });
      var getObj = {
        statusType: 2
      };
      getBrand(getObj).then(function (res) {
        if (res.data.code == 200) {
          _this4.brandOptions = res.data.data;
        } else {
          self.$notification.error({
            message: res.data.message
          });
        }
      });
      getSourcearea(getObj).then(function (res) {
        if (res.data.code == 200) {
          var list = res.data.data;
          _this4.placeOfOriginOptions = list.map(function (item) {
            return {
              label: item.name,
              value: item.id,
              key: item.id
            };
          });
        } else {
          self.$notification.error({
            message: res.data.message
          });
        }
      });

      //获取运输方式列表
      getTransport().then(function (response) {
        if (response.data.code == 200) {
          var list = response.data.data;
          _this4.transportOptions = list.map(function (item) {
            return {
              label: item.name,
              value: item.id,
              key: item.id
            };
          });
        } else {
          _this4.$notification.error({
            message: res.data.message
          });
        }
      });

      // const list = dataList
      // this.categoryOptions = dataList.data.categoryList
      // this.brandOptions = dataList.data.brandList
      // this.transportOptions = dataList.data.transportListVoList.map(item => {
      //   return {
      //     label: item.name,
      //     value: item.id,
      //     key: item.id
      //   }
      // })
      // this.placeOfOriginOptions = dataList.data.sourceAreaList.map(item => {
      //   return {
      //     label: item.name,
      //     value: item.id,
      //     key: item.id
      //   }
      // })
    },
    handleOk: function handleOk() {
      var _this5 = this;
      console.log('this.$refs.formRef', this.$refs.formRef);
      this.$refs.formRef.validate(function (success, values) {
        console.log('validate', {
          success: success,
          values: values
        });
        console.log('validate', _this5.form);
        if (success) {
          if (_this5.form.page === PageTypes.SearchResult) {
            _this5.handleSearchSuccess();
          } else if (_this5.form.page === PageTypes.ActivityDetail) {
            _this5.handleActivityDetail();
          } else if (_this5.form.page === PageTypes.Pdf) {
            _this5.handlePdfSuccess();
          }
          _this5.visible = false;
        }
      });
    },
    handleCancel: function handleCancel() {
      console.log('handleCancel');
      this.$refs.formRef.resetFields();
    },
    /** 拼接PDF **/handlePdfSuccess: function handlePdfSuccess() {
      this.$emit('ok', this.form.query.pdf || '');
    },
    /**
     * 拼接活动详情
     */
    handleActivityDetail: function handleActivityDetail() {
      var query = this.form.query;
      var links = '';
      if (query.activity) {
        links = "/activity/detail?activityId=".concat(query.activity);
      }
      this.$emit('ok', links);
    },
    /**
     * 拼接搜索条件
     */
    handleSearchSuccess: function handleSearchSuccess() {
      var page = this.form.page;
      var query = this.form.query;

      // ?search=老干妈&catagotyId=200&transportId=4&originId=1&brandId=282&orderType=2&sort=1&page=1&bundleChecked=1&exactSearch=0

      /**
       * 为了 和 PC端的参数顺序一致，手动拼接了参数
       * @type {*[]}
       */
      var queryArr = [];
      if (query.catagotyId) {
        queryArr.push("catagotyId=".concat(query.catagotyId));
      }
      if (_.isArray(query.transportId) && query.transportId.length > 0) {
        var transportIdStr = query.transportId.join(this.seq);
        queryArr.push("transportId=".concat(transportIdStr));
      }
      if (query.originId) {
        queryArr.push("originId=".concat(query.originId));
      }
      if (query.brandId) {
        queryArr.push("brandId=".concat(query.brandId));
      }
      if (query.orderType) {
        queryArr.push("orderType=".concat(query.orderType));
      }
      if (query.title) {
        queryArr.push("title=".concat(query.title));
      }
      var links = '';
      var searchStr = '';
      if (query.search) {
        searchStr = "search=".concat(query.search);
      }
      var queryStr = queryArr.join('&');
      if (searchStr || queryStr) {
        if (searchStr && queryStr) {
          links = "".concat(page, "?").concat(searchStr, "&").concat(queryStr);
        } else if (searchStr) {
          links = "".concat(page, "?").concat(searchStr);
        } else {
          links = "".concat(page, "?").concat(queryStr);
        }
      } else {
        links = page;
      }
      links = encodeURI(links);
      this.$emit('ok', links);
    },
    /**
     * 拼接优惠券
     */
    handleCouponSuccess: function handleCouponSuccess() {
      var page = this.form.page;
      var query = this.form.query;

      /**
       * 优惠券链接没有多语言的区分，但是为了统一格式，也安装多语言返回。
       * @type {{}}
       */
      var links = {};
      this.langList.forEach(function (lang) {
        if (query.channelcode) {
          links[lang.langId] = "".concat(page, "?channelcode=").concat(query.channelcode);
        } else {
          links[lang.langId] = page;
        }
        links[lang.langId] = encodeURI(links[lang.langId]);
      });
      this.$emit('ok', links);
    }
  }
};